import { IonButton } from "@ionic/react"
import styled from "styled-components"
import ButtonProps from "../../interfaces/ButtonProps"

export default function StyledButton(props: ButtonProps) {
    return styled(IonButton)`
        --background: ${props.background};
        --color: ${props.color};
        --border-radius: ${props.border_radius};
        border: ${props.border};
        position: ${props.position};
        font-size: ${props.font_size};
        left: ${props.left};

        --box-shadow: ${props.box_shadow};

        margin-left: ${props.marginLeft};
        margin-right: ${props.marginRight};

        width: ${props.width};
        height: ${props.height};
    `
} 